export enum PaymentTypeFilter {
    PaymentPayOff = 'PaymentPayOff',
    Payment = 'Payment',
    PayOff = 'PayOff',
}

//Account Type as it will be received from UI for savePayment
export enum AccountType {
    OperatingLease = 'OperatingLease',
    RetailLoan = 'RetailLoan',
    RetailBalloon = 'RetailBalloon',
    Unknown = 'Unknown',
}

//Bank Account as it will be received from UI for savePayment
export enum BankAccountType {
    Checking = 'Checking',
    Saving = 'Saving',
    CreditLine = 'CreditLine',
}

//Payment Process Status as it will be received from UI for savePayment
export enum PaymentProcessStatus {
    PendingApproval = Number('0'),
    Pending = Number('1'),
    Deleted = Number('2'),
    Submitted = Number('3'),
    BatchDeleted = Number('4'),
}

//Payment Type as it will be received from UI for savePayment
export enum PaymentType {
    None = 'None',
    Payment = 'Payment',
    PayOff = 'PayOff',
}

//Country for savePayment
export enum Country {
    USA = 'USA',
    Canada = 'Canada',
}

//Payment Reason as it will be received from UI for savePayment
export enum PaymentReason {
    RegularPayment = 'RegularPayment',
    Curtailment = 'Curtailment',
    FlatCancel = 'FlatCancel',
    Other = 'Other',
    ChargeBack = 'ChargeBack',
    EndOfTermInvoice = 'EndOfTermInvoice',
    LeaseTransferFee = 'LeaseTransferFee',
}

export enum PaymentDataSearhType {
    Account = 'AccountNumber',
    Vin = 'VIN',
}

export enum PaymentSource {
    Payoff = 'Payoff',
    Quote = 'Quote',
    Payment = 'Payment',
}

export enum PurchaseType {
    DealerInventory = 'DealerInventory',
    CustomerBuyBack = 'CustomerBuyout',
}

export enum SecurityDepositWaiverType {
    AssignToCustomer = 'AssignToCustomer',
    AssignToDealer = 'AssignToDealer',
    Deduct = 'Deduct',
}
